import LotesService from '../../services/LotesService';
import LaboratorioService from '../../services/LaboratorioService';
import { formatarTitleCase, fazerDownloadDeArquivo } from '../../shared/utils/Formatacao';
import { mensagemEtiquetaDadoEnvioVazio } from '../../shared/utils/Constantes';
import { baixarArquivo, handleRequestError } from '../../shared/utils/RequestUtil';
import BrowserUtils from '../../shared/utils/BrowserUtils';
import DadosEnvioService from '../../services/DadosEnvioService';
import store from '../../store';
import { mensagemAlertaActions } from '../../features/mensagemAlerta/redux';

const tratarOpcoesFiltro = (resultado) => {
    if (!resultado || !resultado.length)
        return [];

    resultado.forEach(res => {
        if (res.descricao !== "Kit DNA/KPA") {
            res.descricao = formatarTitleCase(res.descricao);
        }
    });

    return resultado.sort((a, b) => a.descricao.localeCompare(b.descricao));
};

const formatarDadosLotes = (lotes) => {
    if (!lotes || !lotes.length) return;

    lotes.forEach(lo => {
        if (lo.tipoLote && lo.tipoLote.descricao !== "Kit DNA/KPA")
            lo.tipoLote.descricao = formatarTitleCase(lo.tipoLote.descricao);

        if (lo.status)
            lo.status.descricao = formatarTitleCase(lo.status.descricao);
    });
};

class LotesManager {
    async listarLotes(filtros, uuid) {
        return await LotesService.listarLotes(filtros, uuid).then((res) => {
            const resultado = res && res.data
            formatarDadosLotes(resultado.itens);
            return resultado;
        })
    }

    async listarTiposLote() {
        return await LotesService.listarTiposLote(true).then((res) => {
            return res && tratarOpcoesFiltro(res.data)
        })
    }

    async listarStatusLote() {
        return await LotesService.listarStatusLote().then((res) => {
            return res && tratarOpcoesFiltro(res.data)
        })
    }

    async listarAmostrasLote(idLote) {
        return await LotesService.listarAmostrasLote(idLote).then((res) => {
            return res && res.data
        })
    }

    async listarEventosLote(idLote) {
        return await LotesService.listarEventosLote(idLote).then((res) => {
            return res && res.data
        })
    }

    async exportarDadosLote(idLote) {
        const resposta = await LotesService.exportarDadosLote(idLote);

        if (!resposta) return;

        return resposta;
    }

    async baixarPlanilha(operacoesListagem) {
        const resposta = await LotesService.baixarPlanilha(operacoesListagem);

        if (!resposta) return;

        return resposta;
    }

    async baixarRelatorioUtilizacao(periodo) {
        return await LaboratorioService.baixarRelatorioUtilizacao(periodo);
    }

    async imprimirManifestoCarga(lotes) {
        const idsLotes = lotes.map(lote => lote.id);
        const novaAba = BrowserUtils.abrirNovaAbaEmBranco();

        const resposta = await LotesService.obterManifestoCarga(idsLotes);

        const arquivoURL = baixarArquivo(resposta, null, true);
        BrowserUtils.atualizarAbaLocation(novaAba, arquivoURL);
    }

    async gerarReciboRecolhimento(idLote) {
        const novaAba = BrowserUtils.abrirNovaAbaEmBranco();

        const resposta = await LotesService.obterReciboRecolhimento(idLote);

        const arquivoURL = baixarArquivo(resposta, null, true);
        BrowserUtils.atualizarAbaLocation(novaAba, arquivoURL);
    }

    async obterImagemBiopsiaLote(idLote) {
        try {
            const res = await LotesService.obterImagemBiopsiaLote(idLote);
            const nomeArquivo = `${idLote}-ImagemBag.png`;

            fazerDownloadDeArquivo(res.data, nomeArquivo);
        } catch (error) {
            handleRequestError(error);
        }
    }

    async obterImagemAssinaturaLote(idLote) {
        try {
            const res = await LotesService.obterImagemAssinaturaLote(idLote);
            const nomeArquivo = `${idLote}-AssinaturaDigital.png`;

            fazerDownloadDeArquivo(res.data, nomeArquivo);
        } catch (error) {
            handleRequestError(error);
        }
    }

    async imprimirDadosEnvio() {
        await DadosEnvioService.obterDadosEnvio()
            .then((resposta) => {
                if (resposta) {
                    const novaAba = BrowserUtils.abrirNovaAbaEmBranco();

                    const arquivoURL = baixarArquivo(resposta, null, true);
                    BrowserUtils.atualizarAbaLocation(novaAba, arquivoURL);
                }
                else {
                    store.dispatch(mensagemAlertaActions.exibirNotificacao(mensagemEtiquetaDadoEnvioVazio));
                }
            });
    };
}

export default new LotesManager()